import React from "react";
import T from "prop-types";
import { Icon } from "MODULES/shared/components";
import ExternalLink from "MODULES/shared/components/ExternalLink/ExternalLink";

export function Download({ url }) {
  return (
    <li>
      <ExternalLink url={url}>
        <Icon name="file-text-o" fixed />
        &nbsp;Download Packing Slip
      </ExternalLink>
    </li>
  );
}

Download.propTypes = {
  url: T.string.isRequired
};

export default Download;



// WEBPACK FOOTER //
// ./app/modules/MistakeShipments/components/Detail/Actions/Download.jsx